'use client';

import { usePathname } from 'next/navigation';
import useTranslation from 'next-translate/useTranslation';
import { Skeleton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { useGetKeepWatching } from '@/modules/Entertainment/http/client/useGetKeepWatching';
import { WidgetContainer } from '@/components/molecules/Widget/Container';
import { IfRender } from '@/utils/jsx';
import { ContentProgressCard } from '../ContentProgressCard';
export const LastViewWidget = () => {
  const pathname = usePathname();
  const {
    t
  } = useTranslation('common');
  const {
    data: keepWatching = [],
    isLoading
  } = useGetKeepWatching(pathname === PATHS.hubs.research ? 'research' : 'home');
  if (isLoading) {
    return <WidgetContainer containerId="LastView" title={t('widgets.LastViewWidget.title')} buttonLink={PATHS.user.myHistoric}>
        {Array.from({
        length: 10
      }).map((_, idx) => <Skeleton key={idx} w="24rem" h="11.25rem" borderRadius="0.5rem" />)}
      </WidgetContainer>;
  }
  return <IfRender condition={keepWatching.length > 0} data-sentry-element="IfRender" data-sentry-component="LastViewWidget" data-sentry-source-file="index.tsx">
      <WidgetContainer containerId="LastView" title={t('widgets.LastViewWidget.title')} buttonLink={PATHS.user.myHistoric} data-sentry-element="WidgetContainer" data-sentry-source-file="index.tsx">
        {keepWatching.map(({
        id,
        program_type_trans,
        published_at,
        slug,
        summary,
        thumb,
        title,
        watch
      }) => <ContentProgressCard key={id} subtitle={summary} description={`${published_at} • ${program_type_trans}`} progress={watch.percentage} slug={slug} thumbAlt={title} thumbUrl={thumb} title={title} />)}
      </WidgetContainer>
    </IfRender>;
};